import Check from 'resources/icons/Check';
import { ContentStateTypes, NotOptedInTypeMain, SuggestShippingType } from 'types/uiTypes';
import MakeSuggestion from './MakeSuggestion';

type ContainerProps = {
    uiText: NotOptedInTypeMain;
    setState: (state: ContentStateTypes) => void;
    setUiResponse: (response: NotOptedInTypeMain) => void;
};

type ContentProps = {
    uiText: SuggestShippingType;
};

const SuggestionMade = ({ uiText: { title, text } }: ContentProps) => (
    <>
        <Check />
        <p className="font-bold mt-12">{title}</p>
        <p>{text}</p>
    </>
);

const ContentState = ({ setState, uiText, setUiResponse }: ContainerProps) => {
    const { suggestionStatus } = uiText.context!;
    const { suggestShipping } = uiText.sections.sidebar!;
    const shippingAlreadySuggested = suggestionStatus === 'SHIPPING_ALREADY_SUGGESTED';

    if (!suggestShipping) return null;

    if (shippingAlreadySuggested) return <SuggestionMade uiText={suggestShipping} />;

    return (
        <MakeSuggestion
            uiText={suggestShipping}
            setState={setState}
            setUiResponse={setUiResponse}
        />
    );
};

export default ContentState;
